import {useState} from "react";

function SuggestionCell({text}) {
    const [expanded, setExpanded] = useState(false);
    const limit = 80;
    const isLong = text.length > limit;

    return (
        <div style={{fontSize: "13px", color: "#6b7280", maxWidth: "380px"}}>
            <span>{expanded || !isLong ? text : text.slice(0, limit) + "..."}</span>
            {isLong && (
                <div>
                    <button
                        onClick={() => setExpanded(!expanded)}
                        style={{
                            background: "none", border: "none", padding: 0,
                            color: "#4338ca", fontSize: "13px", cursor: "pointer",
                            fontWeight: "500", marginTop: "2px",
                        }}
                    >
                        {expanded ? "Voir moins" : "Voir plus"}
                    </button>
                </div>
            )}
        </div>
    );
}

export default SuggestionCell;
